/* eslint-disable */
import getPropertyForTourClick from "@/js/common/components/tour-page/services/getPropertyForTourClick";
import backboneModelDeepInstanceOf from "@/js/common/Domain/Service/backboneModelDeepInstanceOf";

export default function getTourPropertyForHotTourClick(model) {
	if (!backboneModelDeepInstanceOf({model})) {
		return false
	}
	let tourProducts = model.get('tourProducts');
	let tourProduct = (tourProducts && tourProducts.length && tourProducts.at) ? tourProducts.at(0) : null;
	if (!backboneModelDeepInstanceOf({model: tourProduct, values: ['tour']})) {
		return false;
	}
	let tour = tourProduct.get('tour');
	let properties = {
		...getPropertyForTourClick({tour}),
		...{
			cityFrom: backboneModelDeepInstanceOf({
				model: tourProduct,
				values: ['tourCriteria', 'departureCity']
			}) ? tourProduct.get('tourCriteria').get('departureCity').get('id') : null,
			countryTo: backboneModelDeepInstanceOf({
				model,
				values: ['country']
			}) ? model.get("country").get('id') : null,
			hid: model.get('id') || null
		}
	};

	return properties || false;
}